import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const res = await fetch('https://readdy.ai/api/form/d6co582ohb161tfd85ig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Newsletter subscription failed:', error);
      setStatus('error');
    }
  };

  return (
    <section className="py-24 bg-carbon-900 relative overflow-hidden">
      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-neon/5 blur-[120px]"></div>

      <div className="max-w-2xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <div className="w-14 h-14 bg-neon/10 border border-neon/20 flex items-center justify-center mx-auto mb-6">
          <i className="ri-mail-send-line text-neon text-2xl"></i>
        </div>
        <h2 className="text-4xl font-bold text-white mb-4 tracking-tight">Never Miss a Deal</h2>
        <p className="text-sm text-white/40 mb-10 leading-relaxed">
          Get weekly product recommendations, exclusive discounts, and expert reviews delivered straight to your inbox.
        </p>

        {status === 'success' ? (
          <div className="bg-white/5 border border-neon/20 p-8">
            <div className="w-12 h-12 bg-neon/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-check-line text-neon text-2xl"></i>
            </div>
            <p className="text-white font-bold text-lg">You&apos;re subscribed!</p>
            <p className="text-white/40 text-sm mt-2">Check your inbox for a welcome email.</p>
          </div>
        ) : (
          <form
            id="newsletter-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex items-center bg-white/10 border border-white/20 overflow-hidden max-w-lg mx-auto hover:border-white/30 transition-colors"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-5 py-4 text-sm text-white placeholder-white/50 focus:outline-none bg-transparent"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-4 bg-neon text-black text-sm font-bold hover:bg-neon/90 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-red-400 text-sm mt-4">Something went wrong. Please try again.</p>
        )}

        <p className="text-white/20 text-xs mt-6">No spam, ever. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
